import usuariosMenu from './usuarios/menu';

const senacMenu = {
    label: 'SENAC',
    icon: 'pi pi-fw pi-briefcase',
    rules: [...usuariosMenu.rules],
    items: [usuariosMenu],
};

export default senacMenu